import { useParams } from "react-router-dom";

import { useAreaSuspense } from "@/api/areas/queries";
import { AreaContext } from "@/hooks/useAreaContext";
import { ModuleDetailContext } from "@/hooks/useModuleDetailContext";

type ModuleMaintenanceDataLoaderProps = {
  children: React.ReactNode;
  /** Override the route param. Useful when rendering inside a sheet. */
  areaId?: string;
  /** Override the route param. Useful when rendering inside a sheet. */
  moduleAddress?: string;
};

export type ModuleMaintenanceRouteParams = {
  areaId: string;
  moduleAddress: string;
};

const ModuleMaintenanceDataLoader = ({
  children,
  areaId: areaIdProp,
  moduleAddress: moduleAddressProp,
}: ModuleMaintenanceDataLoaderProps) => {
  const params = useParams<keyof ModuleMaintenanceRouteParams>();
  const areaId = areaIdProp ?? (params.areaId as string);
  const moduleAddress = moduleAddressProp ?? (params.moduleAddress as string);

  const { data: area } = useAreaSuspense({ id: areaId });

  const parsedAddress = Number(moduleAddress);
  const post = area.posts.find((p) => p.address === parsedAddress);

  if (!post) {
    // Validator will handle the "not found" case via a null context check
    return (
      <AreaContext.Provider value={{ area }}>{children}</AreaContext.Provider>
    );
  }

  return (
    <AreaContext.Provider value={{ area }}>
      <ModuleDetailContext.Provider value={{ post }}>
        {children}
      </ModuleDetailContext.Provider>
    </AreaContext.Provider>
  );
};

export default ModuleMaintenanceDataLoader;
